import { render } from "./Invocies.vue?vue&type=template&id=5ead8674&scoped=true"
import script from "./Invocies.vue?vue&type=script&lang=js"
export * from "./Invocies.vue?vue&type=script&lang=js"

import "./Invocies.vue?vue&type=style&index=0&id=5ead8674&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ead8674"]])

export default __exports__